import { render } from "./VerticalStepBar.vue?vue&type=template&id=49b95e80"
import script from "./VerticalStepBar.vue?vue&type=script&lang=js"
export * from "./VerticalStepBar.vue?vue&type=script&lang=js"
script.render = render

export default script